import {Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {ReactNode} from "react";
import {FormattedMessage, MessageDescriptor} from "react-intl";

type Renderer<T> = (value: T) => React.ReactNode;

type Props<Row extends object> = {
    headers: {
        [K in keyof Row]: MessageDescriptor;
    };
    rows: Row[];
    renderers?: {
        [K in keyof Row]?: Renderer<Row[K]>;
    };
};

const defaultRenderer: Renderer<unknown> = (value) => <span>{value as ReactNode}</span>;

function ReadonlyTable<Row extends object>({headers, rows, renderers}: Props<Row>) {
    return (
        <Table>
            <TableHead>
                <TableRow>
                    {Object.values(headers).map((header, index) => (
                        <TableCell key={index}>
                            <FormattedMessage {...(header as MessageDescriptor)} />
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row, index) => (
                    <TableRow key={index}>
                        {Object.keys(headers).map((key, index) => {
                            const renderer = renderers?.[key as keyof Row] || defaultRenderer;
                            return <TableCell key={index}>{renderer(row[key as keyof Row])}</TableCell>;
                        })}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}

export default ReadonlyTable;
